import React from "react";
import ReactDOM from "react-dom";
import HexModal from "../../../app/components/modals/HexModal";
import { findModels } from "../../../infrastructure/repository/benefit-models-repository";
import { findCompanyId } from "../../../infrastructure/repository/company-repository";
import ShowDetailEmployee from "../../../app/components/modals/employee/showDetailEmployee";
import { showErrorMessage } from "../../commons/show-error-message";
import Employee from "../../../app/domain/Employee";
import { logError, addContextLog } from "../../../infrastructure/log";
import { translate } from "../../../infrastructure/translate/localization";

function renderEmployeeModal({
  employee,
  benefitModels,
  taxRegimes,
  errors,
  warnings,
}) {
  ReactDOM.render(
    <HexModal>
      <ShowDetailEmployee
        employee={employee}
        benefitModels={benefitModels}
        taxRegimes={taxRegimes}
        errors={errors}
        warnings={warnings}
        editType="editMassiveEmployee"
      />
    </HexModal>,
    document.getElementById("modal-container")
  );
}

export async function displayUploadSessionEmployee({ employee }) {
  try {
    const companyId = await findCompanyId();
    const { data: benefitModels } = await findModels();

    addContextLog("info", "displayEmployeeDetails", "display-screen", {
      companyId,
      employee,
    });
    renderEmployeeModal({
      employee,
      benefitModels,
      taxRegimes: Employee.taxRegimes,
      errors: employee.error,
      warnings: employee.warning,
    });
  } catch (e) {
    logError(
      e,
      `Error to displayUploadSessionEmployee with employee ${employee.id}`
    );
    showErrorMessage(translate("common-messages.basic-error-message"), true, e);
  }
}
